import { useEffect, useState } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { checkSession } from '../utils/auth'

export default function ProtectedRoute({ children }) {
    const [status, setStatus] = useState('checking')
    const location = useLocation()

    useEffect(() => {
        let cancelled = false
        setStatus('checking')
        checkSession().then((authenticated) => {
            if (!cancelled) setStatus(authenticated ? 'authenticated' : 'unauthenticated')
        })

        const recheck = () => {
            if (document.visibilityState === 'visible') {
                checkSession().then((authenticated) => {
                    if (!cancelled) setStatus(authenticated ? 'authenticated' : 'unauthenticated')
                })
            }
        }
        window.addEventListener('focus', recheck)
        document.addEventListener('visibilitychange', recheck)
        return () => {
            cancelled = true
            window.removeEventListener('focus', recheck)
            document.removeEventListener('visibilitychange', recheck)
        }
    }, [location.pathname])

    if (status === 'checking') {
        return (
            <div className="min-h-screen flex items-center justify-center bg-white dark:bg-zinc-950 text-zinc-500 dark:text-zinc-400 text-sm font-mono">
                Verifying session.
            </div>
        )
    }

    if (status === 'unauthenticated') {
        return <Navigate to="/login" state={{ from: location.pathname }} replace />
    }

    return children
}
